import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';

function GenericFilterFormatter(params, observableOptions, dataSources) {

    var self = this;

    self.observableOptions = observableOptions;

    self.formatterCommon = FormatterCommon;
    self.gridFormatterCommon = new GridFormatterCommon();

    self.systemsTreeFilter = params.systemsTreeFilter || false;
    self.systemsCategory = params.systemsCategory || '*';

    self.showOnlyBridges = params.showOnlyBridges || false;
    self.endpointModelsTreeFilter = params.endpointModelsTreeFilter || false;

    self.dataSources = dataSources;

    self.datapresorted = params && params.datapresorted ? params.datapresorted : false;
    self.dataprepaged = params && params.dataprepaged ? params.dataprepaged : false;

    self.observableParams = dataSources[0].observableParams;

    self.observableFormattedData = ko.observable({});

    self.subscriptions = [];
}

function ComposeData(formatterCommon,
    gridFormatterCommon,
    sourcelist,
    endpointModels,
    systems) {

    var result = {};

    if (sourcelist && !_.isEmpty(sourcelist)) {

        var filters = sourcelist;

        var coloptions = $.map(filters,
            function (filteritem) {
                var hidden = false;
                if ((filteritem.UIColumn !== null) && (filteritem.UIColumn === 0) && (filteritem.columnKey !== "dimendpoint.tag")) { // todo confirm this is not uicolumn
                    hidden = true;
                }
                let column = {
                    name: filteritem.columnKey,
                    title: filteritem.columnDescription,
                    type: filteritem.columnType,
                    hidden: hidden
                };
                if (filteritem.knownValuePath) {
                    column.knownValuePath = filteritem.knownValuePath;
                }
                if (filteritem.datasetId) {
                    column.datasetId = filteritem.datasetId;
                }
                return column;
            });

        result = { columnOptions: coloptions};
    }

    result.endpointModels = endpointModels;
    result.systems = systems;

    return result;

}

GenericFilterFormatter.prototype.RefreshData = function () {
    var self = this;

    if (_.isEmpty(self.observableParams())) {
        return;
    }

    self.sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.FactFilterDictionary, self.observableParams());
    self.endpointModels = self.endpointModelsTreeFilter ? self.dataRepository.endpointModels() : null;

    if (self.systemsTreeFilter) {
        var systems = _.get(self.dataRepository.systemsDictionary(), self.systemsCategory);

        if (self.showOnlyBridges) {
            self.systems = _.filter(systems, function (system) {
                return _.toLower(system["dimsystem.systemCategory"]) === 'bridge';
            });
        }
        else {
            self.systems = systems;
        }
    }
    else {
        self.systems = null;
    }

    if (self.sourceList !== null) {

        self.observableFormattedData(ComposeData(self.formatterCommon,
            self.gridFormatterCommon,
            self.sourceList,
            self.endpointModels,
            self.systems));
    }
};


GenericFilterFormatter.prototype.DataUpdated = function () {
    var self = this;
    self.RefreshData();
};

GenericFilterFormatter.prototype.OptionsUpdated = function () {
    var self = this;
    self.RefreshData();
};

GenericFilterFormatter.prototype.initialize = function (dataRepository, dataProvider) {
    var self = this;

    self.dataRepository = dataRepository;
    self.dataProvider = dataProvider;

    self.RefreshData(); //data for either or both filter dictionary and endpoint models may be loaded already; in case not, listen for updates

    if (!self.sourceList)
    {
        self.subscriptions.push(self.dataRepository.FactFilterDictionary.subscribe(function() {
            self.DataUpdated();
        }));
    }

    if (self.endpointModelsTreeFilter && (!self.endpointModels || !self.endpointModels.length)) {
        self.subscriptions.push(self.dataRepository.endpointModels.subscribe(function () {
            self.DataUpdated();
        }));
    }

    if (self.systemsTreeFilter && _.isEmpty(self.systems)) {
        self.subscriptions.push(self.dataRepository.systemsDictionary.subscribe(function () {
            self.DataUpdated();
        }));

        self.dataProvider.loadSystems(self.systemsCategory);
    }
};


GenericFilterFormatter.prototype.getObservableData = function () {
    var self = this;

    return self.observableFormattedData;
};

GenericFilterFormatter.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

export default GenericFilterFormatter;
